<template>
<main class="mine page sl-mine"><div class="wrapper"><van-pull-refresh v-model="isLoading" :pulling-text="$t('reservation.refresh')" :loosing-text="$t('reservation.refreshpage')" :loading-text="$t('reservation.refresh')" :success-text="$t('reservation.refresh')" @refresh="onRefresh">
  <header class="sl-topbar"><div class="sl-brand"><img src="/sweetlove-logo.png" alt="SweetLove" /></div><button class="sl-icon-button" type="button" @click="goInfomation()" :aria-label="$t('my.personal_center')"><sl-icon name="settings" /></button></header>
  <div class="sl-account-heading"><p class="sl-eyebrow">{{ $t('my.Account_Center') }}</p><h1>{{ $t('my.personal_center') }}</h1></div>
  <section class="sl-profile-card"><button class="sl-profile-main" type="button" @click="doLogin()"><van-image class="sl-avatar" round :src="$natureAvatar(userInfo)"><template #loading><van-loading type="spinner" /></template></van-image><div class="sl-profile-name"><span class="sl-eyebrow">SWEETLOVE MEMBER</span><h2 data-preserve-text>{{ userInfo.username }}</h2><span class="sl-member-chip"><sl-icon name="crown" />VIP {{ userInfo.vip }}</span><span v-if="vip_info.vip < 0" class="sl-account-state">{{ $t('Frozen') }}</span><span v-else-if="vip_info.vip == 0" class="sl-account-state">{{ $t('Unauthenticated') }}</span></div><sl-icon class="sl-profile-arrow" name="arrow" /></button>
  <div class="sl-wallet"><span>{{ $t('my.Account_balance') }}</span><div class="sl-wallet-value"><strong>{{ userInfo.money || 0 }}</strong><span>{{ $t('reservation.unit') }}</span></div><sl-icon class="sl-wallet-decoration" name="wallet" /></div>
  <div class="sl-account-stats"><div><span class="sl-stat-icon"><sl-icon name="crown" /></span><div><span>{{ $t('my.level') }}</span><strong>VIP {{ userInfo.vip }}</strong></div></div><div><span class="sl-stat-icon"><sl-icon name="shield" /></span><div><span>{{ $t('my.score') }}</span><strong>{{ userInfo.score }}</strong></div></div></div></section>
  <section class="sl-section sl-account-menu"><div class="sl-section-heading"><h2>{{ $t('my.Account_Center') }}</h2><sl-icon name="shield" /></div><div class="sl-menu-group">
    <button class="menu-item sl-menu-row" type="button" @click="Login_password()"><span class="sl-menu-icon"><sl-icon name="lock" /></span><span>{{ $t('my.Login_password') }}</span><sl-icon class="sl-menu-arrow" name="arrow" /></button>
    <button class="menu-item sl-menu-row" type="button" @click="$router.push({path:'/GameRecord'})"><span class="sl-menu-icon"><sl-icon name="game" /></span><span>{{ $t('my.task_record') }}</span><sl-icon class="sl-menu-arrow" name="arrow" /></button>
    <button class="menu-item sl-menu-row" type="button" @click="requestBankWithdrawal()"><span class="sl-menu-icon"><sl-icon name="bank" /></span><span>{{ $t('my.withdraw1') }}</span><sl-icon class="sl-menu-arrow" name="arrow" /></button>
    <button class="menu-item sl-menu-row" type="button" @click="requestCryptoWithdrawal()"><span class="sl-menu-icon"><sl-icon name="coin" /></span><span>{{ $t('my.withdraw2') }}</span><sl-icon class="sl-menu-arrow" name="arrow" /></button>
    <button class="menu-item sl-menu-row" type="button" @click="$router.push({path:'/RechargeRecord'})"><span class="sl-menu-icon"><sl-icon name="wallet" /></span><span>充值記錄</span><sl-icon class="sl-menu-arrow" name="arrow" /></button>
    <button class="menu-item sl-menu-row" type="button" @click="$router.push({path:'/WithdrawRecord'})"><span class="sl-menu-icon"><sl-icon name="record" /></span><span>{{ $t('my.account_detail') }}</span><sl-icon class="sl-menu-arrow" name="arrow" /></button>
  </div><button class="sign-out sl-sign-out" type="button" @click="loginout()"><sl-icon name="logout" />{{ $t('setting.logout') }}</button></section>
</van-pull-refresh></div><withdrawal-password-gate v-model="passwordSetupOpen" :is-setup="true" @complete="finishPasswordSetup" @cancel="cancelPasswordSetup" /></main>
</template>

<script>
import withdrawalFlow from "../../common/withdrawal-flow"
export default {
  mixins: [withdrawalFlow],
  data() {
    return {
      userInfo: {},
      menu_top: 40,
      isLoading: false,
      tip_text: "",
      tip_show: false,
      vip_info: {},
    };
  },
  methods: {
    applyCachedUserInfo() {
      const storeUserInfo = this.$store.getters.getUserInfo;
      if (storeUserInfo && Object.keys(storeUserInfo).length > 0) {
        this.userInfo = { ...storeUserInfo };
        this.vip_info = { ...storeUserInfo };
        return true;
      }
      const localUserInfo = localStorage.getItem("cached_user_info");
      if (localUserInfo) {
        try {
          const parsedUserInfo = JSON.parse(localUserInfo);
          if (parsedUserInfo && Object.keys(parsedUserInfo).length > 0) {
            this.userInfo = parsedUserInfo;
            this.vip_info = parsedUserInfo;
            return true;
          }
        } catch (error) {}
      }
      return false;
    },
    loginout() {
      this.$store.commit("setWithdrawalBindingCredential", null);
      localStorage.removeItem("cached_user_info");
      localStorage.clear();
      this.$router.push({ path: "/login" });
    },
    Login_password() {
      this.$router.push("/SetLoginPassword");
    },
    goInfomation() {
      this.$router.push("/Infomation");
    },
    payment() {},

    async refresh() {
      this.isLoading = true;
      if (!localStorage.getItem("token")) {
        this.$router.push({
          path: "/Login",
        });
        this.isLoading = false;
        return;
      }
      try {
        await this.getUserInfo();
        this.$toast(this.$t("reservation.refresh"));
      } finally {
        this.isLoading = false;
      }
    },
    exit() {
      this.$toast(this.$t("my.finish_task"));
    },
    showSetting() {
      // if (localStorage.getItem("token")) {
      //   this.$router.push({
      //     path: "/ServiceOnline",
      //   });
      // } else {
      //   this.$router.push({
      //     path: "/Login",
      //   });
      // }
    },
    toNotice() {
      if (localStorage.getItem("token")) {
        this.$router.push({
          path: "/Notice",
        });
      } else {
        this.$router.push({
          path: "/Login",
        });
      }
    },
    async onRefresh() {
      if (!localStorage.getItem("token")) {
        this.$router.push({
          path: "/Login",
        });
        this.isLoading = false;
        return;
      }
      try {
        await this.getUserInfo();
        this.$toast(this.$t("reservation.refresh"));
      } finally {
        this.isLoading = false;
      }
    },
    doLogin() {
      if (localStorage.getItem("token")) {
        this.$router.push({
          path: "/Infomation",
        });
      } else {
        this.$router.push({
          path: "/Login",
        });
      }
    },
    doPay() {
      this.$router.push({
        name: "Recharge",
        params: {
          balance: this.userInfo.money,
        },
      });
    },
    doWithdrawal() {
      this.$http({
        method: "get",
        url: "user_get_bank",
      }).then((res) => {
        const is_bank = res.data.is_bank;
        if (is_bank) {
          this.$router.push({
            path: "withdraw",
            query: {
              bankinfo: res.data.info.bankinfo,
              bankid: res.data.info.bankid,
              branch_name: res.data.info.branch_name,
              bank_code: res.data.info.bank_code,
              username: res.data.info.username,
            },
          });
        } else {
          this.$router.push("Setbank");
          this.$toast.fail(this.$t("setting.set_bank"));
        }
      });
    },
    doWithdrawal2() {
      this.$http({
        method: "get",
        url: "user_get_bank",
      }).then((res) => {
        if (res.data.crypto.is_bind == true) {
          this.$router.push("Trc20");
        } else {
          this.$router.push("Settrc");
          this.$toast.fail(this.$t("setting.set_bank"));
        }
      });
    },
    toService() {
      if (this.$store.getters.getBaseInfo.iskefu == 1) {
        this.$router.push("ServiceOnline");
      } else {
        this.$toast.fail(this.$t("setting.forbid"));
      }
    },
    getUserInfo() {
      return this.$http({
        method: "get",
        url: "user_info",
        data: {
          type: 1,
        },
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.vip_info = res.data;
          this.$store.commit("setUserInfoValue", res.data);
          localStorage.setItem("cached_user_info", JSON.stringify(res.data));

          this.menu_top = 15;
          /* if (this.userInfo.status !== 1) {
						this.$toast(this.$t("video.account_out"));
						localStorage.clear()
						this.$router.push({
							path: '/Login'
						})
					} */
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
        return res;
      });
    },
  },
  created() {
    if (localStorage.getItem("token")) {
      this.applyCachedUserInfo();
      this.getUserInfo();
    } else {
      this.userInfo.username = this.$t("setting.log_reg");
      this.userInfo.ip = this.$t("setting.more_service");
      this.userInfo.header_img = "img/mine/avatar.png";
    }
  },
};
</script>
